<template>
  <DateField v-bind="$attrs" :display="display" />
</template>

<script>
import DateField from 'Web/Form/Fields/DateField.vue';

export default {
  inheritAttrs: false,
  components: {
    DateField,
  },
  props: {
    display: {
      type: String,
      default: 'HH:mm',
    },
  },
  setup: DateField.setup
}
</script>
